import Popup from "../Popup/Popup";
import { useCallbackState } from "../../Utils/GlobalContext";
import CheckboxList, { filterByTopic } from "../Checkbox/CheckBox";
import { TransformedEvent } from "../../Utils/ParsingUtil";

const POPUP_TITLE = "Termine nach Themen filtern ";
const BUTTON_TITLE = "filtern";

interface FilterProps {
  closePopup: () => void;
}

function FilterAppointments({ closePopup }: FilterProps) {
  const {
    appointments,
    setFilteredAppointmnets,
    checkBoxAppointment,
    setCheckBoxAppointment,
  } = useCallbackState();
  
  const handleDownloadButtonClick = () => {
    const filteredByTopic: TransformedEvent[] = filterByTopic(
      appointments,
      checkBoxAppointment
    );
    setFilteredAppointmnets(filteredByTopic);
  };
  const filterAppointments = true;
  return (
    <Popup
      close={closePopup}
      handleButtonClick={handleDownloadButtonClick}
      popupTitle={POPUP_TITLE}
      buttonTitle={BUTTON_TITLE}
      hideButton={filterAppointments}
    >
      <div>
        <div className="popup-content">
          <div className="date-range-popup"></div>
          <CheckboxList
            checkedAppointment={checkBoxAppointment}
            setCheckedAppointment={setCheckBoxAppointment}
            filterAppointments={filterAppointments}
          />
        </div>
      </div>
    </Popup>
  );
}

export default FilterAppointments;
